import React, { useMemo, useState } from 'react';
import { Stack, Chip, IconButton, TextField, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export function MultiStringInput({ label = 'Update Numbers', value = [], onChange, placeholder = 'Type and add' }) {
  const [draft, setDraft] = useState('');

  const normalized = useMemo(() => {
    const uniq = Array.from(new Set((value || []).map(v => String(v || '').trim()).filter(Boolean)));
    return uniq;
  }, [value]);

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    onChange([...normalized, v]);
    setDraft('');
  };

  const remove = (idx) => {
    const next = [...normalized];
    next.splice(idx, 1);
    onChange(next);
  };

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          label={label}
          size="small"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); add(); }
          }}
          fullWidth
          placeholder={placeholder}
        />
        <Tooltip title="Add">
          <span>
            <IconButton onClick={add} disabled={!draft.trim()}>
              <AddIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
        {normalized.map((v, i) => (
          <Chip key={`${v}-${i}`} label={v} onDelete={() => remove(i)} size="small" variant="outlined" sx={{ mb: 1 }} />
        ))}
      </Stack>
    </Stack>
  );
}
